import { useState } from "react";
import { fr } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { Button } from "./ui/button";
import { formatFrDate } from "../lib/date";

function toISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function DatePicker({ value, onChange, testid, placeholder = "Choisir une date" }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          data-testid={testid}
          type="button"
          variant="outline"
          className="h-12 w-full min-w-0 overflow-hidden justify-start text-base bg-secondary border-border font-normal hover:bg-secondary/80"
        >
          <CalendarIcon size={18} className="mr-2 text-muted-foreground shrink-0" />
          {value ? <span className="truncate">{formatFrDate(value)}</span> : <span className="text-muted-foreground truncate">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-card border-border" align="start">
        <Calendar
          mode="single"
          locale={fr}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => {
            if (d) {
              onChange(toISODate(d));
              setOpen(false);
            }
          }}
          disabled={{ before: today }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
